import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import StockService from "../services/StockService";

export const StockContext = createContext("StockContext");

const StockContextProvider = ({ children }) => {
	const [stockList, setStockList] = useState([]);
	const [totalElements, setTotalElements] = useState(0);
	const [loadingStockList, setLoadingStockList] = useState(false);
	const [stockListErrorMsg, setStockListErrorMsg] = useState("");

	const getStockList = async (params) => {
		setLoadingStockList(true);
		try {
			setStockListErrorMsg("");
			const response = await StockService.getStockList(params);
			setStockList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setStockListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingStockList(false);
		}
	};

	const verifyStock = async (id) => {
		try {
			await StockService.verifyStock(id);
			Toast("success", "Success", "Stock verified successfully.");
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			Toast("error", "Error", message);
			throw error;
		}
	};

	return (
		<StockContext.Provider
			value={{
				getStockList,
				verifyStock,
				stockList,
				totalElements,
				loadingStockList,
				stockListErrorMsg,
			}}
		>
			{children}
		</StockContext.Provider>
	);
};

export default StockContextProvider;
